import React from "react";
var classNames = require("classnames");

const Error = ({ errorName, className }) => {
  return (
    <>
      {errorName && (
        <span className={classNames("text-red-500 text-xs", className)}>
          {errorName.message}
        </span>
      )}
    </>
  );
};

export default Error;
